import React from 'react';
import { Button } from '../../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../../components/Common/Icons/Icons';
import { useMessageManagerProvider } from '../../../../../../context/messageManager';

function EmptyModel() {
  const { state, handleDispatch } = useMessageManagerProvider();

  return (
    <div className="text-center self-center justify-center">
      <div className="text-primary mb-[10px] text-xl font-bold">Test Criteria</div>
      <div className="opacity-50 mb-[20px]">Generate document previews based on criteria</div>
      <Button
        className="p-[10px_15px]"
        onClick={() => {
          handleDispatch({ step3: { ...state.step3, isEdit: true } });
        }}
      >
        <Icons.PlusFilled className="opacity-60" />
        Add Criteria
      </Button>
    </div>
  );
}

export default EmptyModel;
